import { combineReducers } from "redux";
import user from "./user";
import patients from "reducers/patient";
import folderManager from "reducers/folderManager";
import analysisLibrary from "reducers/analysisLibrary";
import admin from "reducers/admin";
import labAppointment from "reducers/labAppointment";
import generalParameters from "reducers/generalParameter";
import round from "reducers/round";
import centers from "reducers/center";
import boxes from "reducers/box";
import prescriptions from "reducers/prescription";
import insurances from "reducers/insurance";
import specialRegimes from "reducers/specialRegime";
import providers from "reducers/provider";
import doctors from "reducers/doctor";
import companies from "reducers/company";
import specialties from "reducers/specialty";
import laboratories from "reducers/laboratory";
import nurses from "reducers/nurse";
import postalCodes from "reducers/postalCode";
import cities from "reducers/city";
import streets from "reducers/street";
import emergencyReasons from "reducers/emergencyReason";
import tubeReasons from "reducers/tubeReason";
import tubeLibrary from "reducers/tubeLibrary";
import tubes from "reducers/tube";
import folderHelp from "reducers/folderHelp";
import contactComments from "reducers/contactComment";
import foldersOverview from "reducers/foldersOverview";
import logs from "reducers/log";
import consentRefusalReasons from "reducers/consentRefusalReason";
import documentTypes from "reducers/documentType";
import dualScreen from "reducers/dualScreen";
import secretaryMode from "reducers/secretaryMode";
import geslab from "reducers/geslab";
import validationPausedReasons from "reducers/validationPausedReason";
import safeplace from "reducers/safeplace";
import ws from "reducers/ws";
import scanner from "reducers/scanner";
import live from "reducers/live";
import preregister from "reducers/preregister";
import deposit from "reducers/deposit";
import campaigns from "reducers/campaign";
import road from "reducers/road";
import express from "reducers/express";

export default combineReducers({
	user,
	patients,
	folderManager: folderManager,
	analysisLibrary,
	admin,
	labAppointment,
	generalParameters,
	round,
	centers,
	boxes,
	prescriptions,
	insurances,
	specialRegimes,
	providers,
	doctors,
	companies,
	specialties,
	laboratories,
	nurses,
	folderHelp,
	postalCodes,
	cities,
	streets,
	emergencyReasons,
	contactComments,
	tubeReasons,
	tubeLibrary,
	tubes,
	foldersOverview,
	logs,
	consentRefusalReasons,
	documentTypes,
	dualScreen,
	secretaryMode,
	geslab,
	validationPausedReasons,
	safeplace,
	ws,
	scanner,
	live,
	preregister,
	deposit,
	campaigns,
	road,
	express,
});
